import { render } from "./app.vue?vue&type=template&id=10db771d"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=10db771d&lang=scss"
script.render = render

export default script